"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferReminderTemplateResponseSchema = exports.OfferReminderTemplateResultSchema = exports.OfferReminderTemplateListResponseSchema = exports.OfferReminderTemplateListResultSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
const OfferReminderTemplateListItemSchema = schemas_1.JobOfferreminderTemplateSchema.pick({
    id: true,
    name: true,
    subject: true,
    updatedAt: true,
});
exports.OfferReminderTemplateListResultSchema = zod_1.z
    .object({ templates: OfferReminderTemplateListItemSchema.array() })
    .merge(schemas_1.PaginationResponseSchema);
exports.OfferReminderTemplateListResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.OfferReminderTemplateListResultSchema);
exports.OfferReminderTemplateResultSchema = zod_1.z.object({ template: schemas_1.JobOfferreminderTemplateSchema });
exports.OfferReminderTemplateResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.OfferReminderTemplateResultSchema);
